
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21.707 3.707L16.414 9H20a1 1 0 110 2h-6a1 1 0 01-1-1V4a1 1 0 112 0v3.586l5.293-5.293a1 1 0 111.414 1.414zM4 13a1 1 0 100 2h3.586l-5.293 5.293a1 1 0 101.414 1.414L9 16.414V20a1 1 0 102 0v-6a1 1 0 00-1-1H4z","fill":"#04080E"}})])
          )
        }
      }
    